import React from 'react';

export default function Pagination({ page, pages, onChange }) {
  if (!pages || pages <= 1) return null;
  const nums = [];
  for (let i = 1; i <= pages; i += 1) {
    if (i === 1 || i === pages || Math.abs(i - page) <= 1) nums.push(i);
    else if (nums[nums.length - 1] !== '…') nums.push('…');
  }
  return (
    <div className="sf-pagination flex items-center justify-center flex-wrap gap-2 mt-10">
      {page > 1 && (
        <button type="button" className="prev" onClick={() => onChange(page - 1)} aria-label="Previous page">«</button>
      )}
      {nums.map((n, i) =>
        n === '…' ? (
          <span key={`d${i}`} className="deco">…</span>
        ) : (
          <span key={n} className={`page ${n === page ? 'current' : ''}`}>
            {n === page ? n : <button type="button" onClick={() => onChange(n)}>{n}</button>}
          </span>
        )
      )}
      {page < pages && (
        <button type="button" className="next" onClick={() => onChange(page + 1)} aria-label="Next page">»</button>
      )}
    </div>
  );
}
